import styled, { css } from 'styled-components';

import ExternalLink from 'components/external-link';
import Link from 'components/link';

import theme from './theme';

export const MAX_CAROUSEL_WIDTH = 1600;

export const CarouselContainer = styled.div<{ $topInset: number }>`
  position: relative;
  display: flex;
  justify-content: center;
  background-color: ${p => p.theme.token('main-menu-carousel-background')};
  padding: 0 96px;
  margin-top: ${p => p.$topInset}px;
  margin-bottom: 2px;

  ${Styles.mobile`
    display: none;
  `}

  .slider {
    position: relative;
    max-width: ${MAX_CAROUSEL_WIDTH}px;

    .slider-frame .slider-list {
      margin: 1px 0 !important;
    }
  }
`;

const tileStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: ${Styles.fontFamily.base};
  padding: 1.3rem 0 1rem 0;
`;

export const TileExternal = styled(ExternalLink)`
  ${tileStyles}
  text-decoration: none;
`;

export const TileWithoutCurrent = styled(Link)`
  ${tileStyles}
`;

export const Tile = styled(TileWithoutCurrent)`
  &[aria-current='page'] * {
    color: ${Styles.color.tertiary};

    &::before {
      content: '';
      background-color: ${Styles.color.tertiary};
      height: 2px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
`;

export const TileImageWrapper = styled.div`
  border-radius: 10px;
  margin: 0 auto;
  width: 80%;
  overflow: hidden;
  margin-bottom: 0.5rem;
  text-align: center;

  > img {
    height: 45px;
  }
`;

export const TileLabel = styled(Link)`
  font-size: ${theme.fontSize};
  text-align: center;
`;
